<p class="attrib_settings_container">
  <span class="attrib_setting_name">{{ displayName }}</span>
  <button mat-button class="attrib_clear_button" type="button" (click)="clearAttrib()">
    <mat-icon class="attrib_setting_clear_icon">close</mat-icon>
  </button>
</p>
<form [formGroup]="formGroup">
  @for (option of checkboxOptions; track option) {
    <mat-checkbox [formControlName]="option">{{ option }}</mat-checkbox>
  }
</form>
